import { render } from "./SingleCheckbox.vue?vue&type=template&id=f16f2a84&scoped=true&ts=true"
import script from "./SingleCheckbox.vue?vue&type=script&lang=ts"
export * from "./SingleCheckbox.vue?vue&type=script&lang=ts"

import "./SingleCheckbox.vue?vue&type=style&index=0&id=f16f2a84&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16f2a84"]])

export default __exports__